import { Navigate } from "react-router-dom";
import MarketingLayout from "@/components/MarketingLayout";
import { SOLUTION_CHANNELS } from "@/data/solutionChannels";
import SolutionPageNew from "@/pages/newsite/SolutionPageNew";

export default function SolutionChannelPage({ channelKey }) {
  const data = SOLUTION_CHANNELS[channelKey];
  if (!data) {
    return <Navigate to="/solutions" replace />;
  }

  const slugByKey = {
    meta: "meta-ads",
    tiktok: "tiktok-ads",
    google: "google-ads",
    pricing: "competitor-pricing",
  };

  return (
    <MarketingLayout>
      <SolutionPageNew slug={slugByKey[channelKey]} />
    </MarketingLayout>
  );
}
